import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionUpdateCardTaskStatusCodes = {
  AutomationV2ExecutionActionUpdateCardTaskStatusFailedToUpdateTaskStatus: {
    code: 'automation-v2-execution-action/update-card-task-status-failed-to-update-task-status',
    explanation: `Falha ao marcar tarefa como feita/não feita.

**Causas comuns:**
- Tarefa não existe mais
- Tarefa em card arquivado

**Como diagnosticar:**
Verifique se a tarefa e o card ainda existem e estão ativos.`,
    localizations: {},
    message: 'Houve um erro ao tentar atualizar o status da tarefa do card.',
    supportingDocs: [
      {
        name: 'Ação de Atualizar Status da Tarefa do Card',
        path: '/wiki/docs/automations/actions/update-card-task-status',
      },
      {
        name: 'Alterando o Status das Tarefas',
        path: '/wiki/docs/cards/tasks/updating-task-status',
      },
    ],
  },
  AutomationV2ExecutionActionUpdateCardTaskStatusMissingCardTaskId: {
    code: 'automation-v2-execution-action/update-card-task-status-missing-card-task-id',
    explanation: `ID da tarefa é obrigatório.

**Causas comuns:**
- Variável taskId não resolvida

**Como resolver:**
Forneça o ID da task a ser atualizada.`,
    localizations: {},
    message: 'ID da tarefa do card não foi fornecido.',
    supportingDocs: [
      {
        name: 'Ação de Atualizar Status da Tarefa do Card',
        path: '/wiki/docs/automations/actions/update-card-task-status',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
